// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-message {
  margin-top: 4em;
  margin-bottom: 4em;
  width: 100%;
}

.boton {
  padding: 0.5em;
  width: 280px;
}

#web {
  color: #BE1111;
}

#guia:hover, #guiaWeb:hover, #formu:hover, #idcat {
  color: #6E374B;
  text-decoration: underline;
}

.btn-warning {
  font-size: calc(14px + 2 * (100vw - 320px) / 1600);
  font-weight: 600;
  min-height: 40px;
  background-color: #FFA429;
  -webkit-box-align: center;
  transition: all 0.3s ease-in;
  border-radius: 8px;
  border-color: #FFA429;
  transition: all 0.3s ease-in;
  color: #fff;
  align-items: center;
  justify-content: center;
  min-width: 100%;
}

.btn-warning:active, .btn-warning:focus, .btn-warning:hover {
  background-color: #E66819 !important;
  border-color: #E66819 !important;
  transition: all 0.3s ease-in;
  color: #fff !important;
}

.btn-warning:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

@media (max-width: 500px) {
  .iconomobil {
    margin-left: 10px;
  }
  .labelmovil {
    font-size: 0;
  }
  .imagenmobil {
    width: 38px;
  }
  /*.mat-icon {
    height: 44px;
    width: 44px;
  }*/
  .ajustemobil {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    padding: 0 !important;
  }
}
.iconomobil, .iconoflecha {
  font-size: 1.2rem;
}

.iconomobil {
  overflow: inherit;
}

.iconoflecha {
  margin-left: 10px;
}

.dropdown-menu {
  min-width: 18vw !important;
}

@media (max-width: 500px) {
  .dropdown-menu {
    min-width: 65vw !important;
  }
}
.foldersize {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}

.tamanIcon {
  height: 20px !important;
  width: 20px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
